import React from 'react';
import { Button, Modal } from '@themesberg/react-bootstrap';
import { generateRandomId } from '../../../../utils/string';
import { useTranslation } from 'react-i18next';
import TableOnly from '../IndividualScheme/TableOnly';

const SchemeInfoModal = (props) => {
  const { showModal, closeModal, data, columns, title } = props;
  const { t } = useTranslation();

  return (
    <div>
      <>
        <Modal
          id={generateRandomId()}
          as={Modal.Dialog}
          centered
          show={showModal}
          onHide={closeModal}
          size="xl"
        >
          <Modal.Header>
            <Modal.Title className="h6">{title || t(`All Scheme Actions`)}</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={closeModal} />
          </Modal.Header>
          <Modal.Body>
            <TableOnly id="SchemeInfoModal" data={data} columns={columns} />
          </Modal.Body>
        </Modal>
      </>
    </div>
  );
};

export default SchemeInfoModal;
